module.exports = __webpack_public_path__ + "media/images/user/favicons/apple-touch-icon-76x76-precomposed-619357942cac7920f298091952520d8f.png";